import { Fragment, useEffect, useState } from 'react';
import { KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIList from 'UIComponents/list/UIList';
import ProductTierIcon from './ProductTierIcon';
import Small from 'UIComponents/elements/Small';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import { CARD_BOX_SHADOW, INNER_CARD_BORDER_RADIUS, NEXT_COMPONENT_SPACING } from 'developer-docs-shared-components/config/cssConstants';

/**
 * BaseProductTier has minimal layout styling applied, so that the consumer can determine the positioning of the component on the page
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUICardWrapper = styled(UICardWrapper).withConfig({
  displayName: "BaseProductTier__StyledUICardWrapper",
  componentId: "aertwb-0"
})(["box-shadow:", ";border-radius:", "px;font-size:14px;margin-bottom:", "px;", "{max-width:fit-content;}svg{margin-right:10px;position:relative;top:2.5px;}"], CARD_BOX_SHADOW, INNER_CARD_BORDER_RADIUS, NEXT_COMPONENT_SPACING, mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));
const H4 = styled(FormattedMessage).withConfig({
  displayName: "BaseProductTier__H4",
  componentId: "aertwb-1"
})(["font-size:16px;"]);
const StyledUICardHeader = styled(UICardHeader).withConfig({
  displayName: "BaseProductTier__StyledUICardHeader",
  componentId: "aertwb-2"
})(["background-color:", ";border-radius:", "px ", "px 0 0;"], KOALA, INNER_CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS);
const UL = styled(UIList).withConfig({
  displayName: "BaseProductTier__UL",
  componentId: "aertwb-3"
})(["font-size:15.5px;&&{padding:14px 12px 18px 12px;}"]);
const TIER_VALUES = ['free', 'starter', 'professional', 'enterprise'];
const PRODUCT_LABELS = {
  marketing_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.marketingHubProductName",
    useGap: true
  }),
  sales_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.salesHubProductName",
    useGap: true
  }),
  service_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.serviceHubProductName",
    useGap: true
  }),
  cms: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.contentHubProductName",
    useGap: true
  }),
  operations_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.operationsHubProductName",
    useGap: true
  })
};
const BaseProductTier = props => {
  const {
    tiers
  } = props;
  const [minimums, setMinimums] = useState({});
  useEffect(() => {
    const newMinimums = {};
    const setMinIfRequired = newProductTier => {
      const productThenTier = newProductTier.split('-');
      const newIndex = TIER_VALUES.indexOf(productThenTier[1]);
      if (newMinimums[productThenTier[0]] && newIndex < newMinimums[productThenTier[0]]) {
        newMinimums[productThenTier[0]] = newIndex;
      } else if (typeof newMinimums[productThenTier[0]] === 'undefined') {
        newMinimums[productThenTier[0]] = newIndex;
      }
    };
    for (let i = 0; i < tiers.length; i++) {
      if (tiers[i].includes('marketing_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('sales_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('service_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('cms-')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('operations_hub')) {
        setMinIfRequired(tiers[i]);
      }
    }
    setMinimums(newMinimums);
  }, [tiers]);
  const products = Object.keys(minimums);
  return /*#__PURE__*/_jsxs(StyledUICardWrapper, {
    compact: true,
    className: "card-wrapper",
    children: [/*#__PURE__*/_jsx(StyledUICardHeader, {
      title: /*#__PURE__*/_jsx(H4, {
        message: "developer-docs-mdx-components.productTier.header"
      })
      // Use md/h4 so on the same level as 'Use cases' for hierarchy, when navigating sections in a screen reader: https://git.hubteam.com/HubSpot/UIComponents/blob/478e2e41670665be39af00ad23d60f8369562b3c/UIComponents/static-3.4636/js/card/UICardHeader.tsx#L44
      ,
      titleSize: "md"
    }), /*#__PURE__*/_jsx(Small, {
      className: "p-x-5 p-top-5 p-bottom-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-mdx-components.productTier.description"
      })
    }), /*#__PURE__*/_jsx(UL, {
      childClassName: "m-bottom-2",
      children: products.map(product => {
        const tier = TIER_VALUES[minimums[product]];
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(ProductTierIcon, {
            tier: product
          }), /*#__PURE__*/_jsx("strong", {
            children: PRODUCT_LABELS[product]
          }), "-", /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-mdx-components.productTier.${tier}ProductTier`,
            useGap: true
          })]
        }, product);
      })
    })]
  });
};
export default BaseProductTier;